import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Countdown.style';

class Countdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            days: 0,
            hours: 0,
            min: 0,
            sec: 0,
        }
    }

    componentDidMount() {
        const { currentDate } = this.props;

        let currentTime = currentDate ? new Date(currentDate) : new Date();
        let testTime = 'Fri Nov 25 2022 12:55:00 GMT+0200 (Eastern European Standard Time)'

        // update every second
        this.interval = setInterval(() => {
            const date = this.calculateCountdown(
                this.props.date.replace(/-/g,'/').replace('GMT+0200', 'GMT+0300'),
                // testTime,
                currentTime
            );
            currentTime = new Date(currentTime.getTime() + 1000);
            if (date) {
                this.setState(date);
            }
            else {
                const { onCountdownExpired } = this.props;
                onCountdownExpired?.call();
                this.stop();
            }
        }, 1000);
    }

    componentWillUnmount() {
        this.stop();
    }

    calculateCountdown(endDate,todayDate) {
        let diff = (Date.parse(new Date(endDate)) - Date.parse(new Date(todayDate))) / 1000;

        // clear countdown when date is reached
        if (diff < 0) return false;

        const timeLeft = {
            years: 0,
            days: 0,
            hours: 0,
            min: 0,
            sec: 0
        };

        // calculate time difference between now and expected date
        if (diff >= (365.25 * 86400)) { // 365.25 * 24 * 60 * 60
            timeLeft.years = Math.floor(diff / (365.25 * 86400));
            diff -= timeLeft.years * 365.25 * 86400;
        }
        if (diff >= 86400) { // 24 * 60 * 60
            timeLeft.days = Math.floor(diff / 86400);
            diff -= timeLeft.days * 86400;
        }
        if (diff >= 3600) { // 60 * 60
            timeLeft.hours = Math.floor(diff / 3600);
            diff -= timeLeft.hours * 3600;
        }
        if (diff >= 60) {
            timeLeft.min = Math.floor(diff / 60);
            diff -= timeLeft.min * 60;
        }
        timeLeft.sec = diff;

        return timeLeft;
    }

    stop() {
        clearInterval(this.interval);
    }

    addLeadingZeros(value) {
        value = String(value);
        while (value.length < 2) {
            value = '0' + value;
        }
        return value;
    }

    render() {
        const { days, hours, min, sec } = this.state;

        return (
        <div block="Countdown">
            <div block="Countdown" elem="Item">
                <strong>{ this.addLeadingZeros(days) }</strong>
                <span>{ days === 1 ? __("Day") : __("Days") }</span>
            </div>
            <div block="Countdown" elem="Item">
                <strong>{ this.addLeadingZeros(hours) }</strong>
                <span>{ hours === 1 ? __("Hour") : __("Hours") }</span>
            </div>
            <div block="Countdown" elem="Item">
                <strong>{ this.addLeadingZeros(min) }</strong>
                <span>{ __('min') }</span>
            </div>
            <div block="Countdown" elem="Item">
                <strong>{ this.addLeadingZeros(sec) }</strong>
                <span>{ __('sec') }</span>
            </div>
        </div>
        );
    }
}

Countdown.propTypes = {
    date: PropTypes.string.isRequired
};

Countdown.defaultProps = {
    date: new Date()
};

export default Countdown;
